import { useEffect, useState } from 'react';
import { LanguageCode } from '@tink/config/src/markets';
import {
  Messages,
  MessagesInLocales,
} from '@tink/core/src/components/providers/LanguageProvider/LanguageProvider';
import { captureMessage } from '@tink/core/src/sentry';
import translationsEn from './translations/en-US.json';

const englishMessages = {
  en: translationsEn,
};

const messagesFileNamesWithoutExtension = {
  [LanguageCode.cs]: 'cs',
  [LanguageCode.da]: 'da',
  [LanguageCode.de]: 'de-DE',
  [LanguageCode.es]: 'es-ES',
  [LanguageCode.et]: 'et-EE',
  [LanguageCode.fi]: 'fi',
  [LanguageCode.fr]: 'fr-FR',
  [LanguageCode.it]: 'it-IT',
  [LanguageCode.lt]: 'lt-LT',
  [LanguageCode.lv]: 'lv-LV',
  [LanguageCode.nl]: 'nl-NL',
  [LanguageCode.no]: 'no',
  [LanguageCode.pt]: 'pt-PT',
  [LanguageCode.pl]: 'pl',
  [LanguageCode.sv]: 'sv-SE',
  [LanguageCode.en]: 'en-US',
};

const importMessagesDynamically = async (languageCode: LanguageCode): Promise<Messages> => {
  let messages = englishMessages.en;

  try {
    const languageFile = await import(
      `./translations/${messagesFileNamesWithoutExtension[languageCode]}.json`
    );

    messages = languageFile.default;
  } catch (error) {
    captureMessage(
      `Failed to import '${messagesFileNamesWithoutExtension[languageCode]}', defaulting to 'en-US.json'.`
    );
  }

  return messages;
};

const useMessages = (languageCode: LanguageCode) => {
  const [messages, setMessages] = useState<MessagesInLocales>({});

  useEffect(() => {
    const setMessagesAsyncronously = async () => {
      const importedMessages = await importMessagesDynamically(languageCode);

      setMessages({
        [languageCode]: importedMessages,
      });
    };
    setMessagesAsyncronously();
  }, [languageCode]);

  return messages;
};

export { useMessages, englishMessages };
